import ApiService from "./api.service";

const TextPageService = {
  async textPages() {
    try {
      return await ApiService.get("user-text-pages");
    } catch (error) {
      return error.response;
    }
  },
  async textPage(slug) {
    try {
      return await ApiService.get(`text-pages/slug/${slug}`);
    } catch (error) {
      console.log(error);
    }
  },
  async newsFeeds(page = 1) {
    try {
      return await ApiService.get(`userNewsFeeds?page=${page}`);
    } catch (error) {
      return error.response;
    }
  },
  async textPageBySlug(slug) {
    try {
      return await ApiService.get(`text-pages/slug/${slug}`);
    } catch (error) {
      console.log(error);
    }
  },

  async aboutPage() {
    try {
      return await ApiService.get(`about-page-info`);
    } catch (error) {
      console.log(error);
    }
  },
};

export { TextPageService };
